// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import TaskEditScreen from "../../../src/screens/tasks/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} TaskEditRouteProps */

/** @typedef {Record<string, never>} TaskEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<TaskEditRouteProps, TaskEditRouteState>}
 */
class TaskEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit task")}</ScreenTitle>
        <TaskEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<TaskEditRouteProps>} */
const TaskEditRouteComponent = memo(shapeComponent(TaskEditRoute))

export default TaskEditRouteComponent
